import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

import FormPage from "@/pages/FormPage";
import TermsPage from "@/pages/TermsPage";
import PolicyPage from "@/pages/PolicyPage";
import AccessPage from "@/pages/AccessPage";
import AccessCodePage from "@/pages/AccessCodePage";

import MainPage from "@/pages/MainPage";

const routes = [
  { path: "/", component: MainPage, meta: { requiresId: true } },
  /*{ path: "/terms", component: TermsPage, meta: { title: "Termos de Uso" } },
  {
    path: "/policy",
    component: PolicyPage,
    meta: { title: "Política de Privacidade" },
  },
  {
    path: "/access",
    component: AccessPage,
    meta: { title: "Criando Acesso" },
  },
  {
    path: "/access/code",
    component: AccessCodePage,
    meta: { title: "Código de Acesso" },
  },
  { path: "/form", component: MainPage },*/
];

const router = new VueRouter({
  mode: "history",
  hash: false,
  routes: routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
    ? `PagBrasil - ${to.meta.title}`
    : "PagBrasil - Formulário KYC";

  if (to.meta.requiresId) {
    const id = to.query.id;
    if (typeof id !== "string" || id.trim() === "") {
      return;
    }
  }

  next();
});

export default router;
